/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Step3title1Inputs */

const he_extension_step3title1 = /** @type {(inputs: Extension_Step3title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפה במידע`)
};

const en_extension_step3title1 = /** @type {(inputs: Extension_Step3title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View the Data`)
};

/**
* | output |
* | --- |
* | "View the Data" |
*
* @param {Extension_Step3title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_step3title1 = /** @type {((inputs?: Extension_Step3title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Step3title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_step3title1(inputs)
	return en_extension_step3title1(inputs)
});
export { extension_step3title1 as "extension_step3Title" }